import { create } from 'zustand';

import { Flota } from '@/shared/interfaces';
import {
  GetFlotasParams,
  getFlotasAll,
} from '../../../shared/actions/erp/flotas.actions';

interface FlotaState {
  flotas: Flota[];
  isLoadingFlotas: boolean;
  getFlotas: (params?: GetFlotasParams) => Promise<void>;

  flotasPreagendamiento: Flota[];
  isLoadingFlotasPreagendamiento: boolean;
  getFlotasPreagendamiento: (params?: GetFlotasParams) => Promise<void>;

  flotaAdicional: Flota[];
  getFlotaAdicional: (params?: GetFlotasParams) => Promise<void>;

  //* flota pymes
  flotaPyme: Flota[];
  getFlotaPyme: (params?: GetFlotasParams) => Promise<void>;
}

export const useFlotasStore = create<FlotaState>(set => ({

  ///* Global
  flotas: [],
  isLoadingFlotas: false,
  getFlotas: async params => {
    set({ isLoadingFlotas: true });
    const { data } = await getFlotasAll(params);
    set({ flotas: data.data });
    set({ isLoadingFlotas: false });
  },

  ///* Preagendamiento solo para ventas, el vendedor no puede ver el nombre de la flota
  flotasPreagendamiento: [],
  isLoadingFlotasPreagendamiento: false,
  getFlotasPreagendamiento: async params => {
    set({ isLoadingFlotasPreagendamiento: true });
    const { data } = await getFlotasAll(params);
    const aux = data.data.map((value, index) => {
      return {
        ...value,
        numero_tecnico: index,
      }
    })
    set({ flotasPreagendamiento: aux });
    set({ isLoadingFlotasPreagendamiento: false });
  },

  ///* flotas para pymes
  flotaPyme: [],
  getFlotaPyme: async params => {
    set({ isLoadingFlotas: true });
    const { data } = await getFlotasAll(params);
    set({ flotaAdicional: data.data });
    set({ isLoadingFlotas: false });

  },

  ///* flotas adicional para ventas pyme
  flotaAdicional: [],
  getFlotaAdicional: async params => {

    const { data } = await getFlotasAll(params);
    set({ flotaAdicional: data.data });

  },
}));
